<form class="vc-admin-form vc-admin-export-patients" (ngSubmit)="exportData()">
  <header class="vc-admin-form__intro">
    <h3 class="vc-admin-form__title">{{ "ADMIN.DATA.EXPORT.PATIENTS" | translate }}</h3>
    <p class="vc-admin-form__subtitle">{{ "ADMIN.DATA.EXPORT.PATIENTS_DESCRIPTION" | translate }}</p>
  </header>

  <section class="vc-admin-form__section">
    <div class="field">
      <label for="export-patient-sites">{{ "ADMIN.DATA.EXPORT.SELECTOR.SITES" | translate }} *</label>
      <p-multiSelect
        inputId="export-patient-sites"
        name="sites"
        size="small"
        [options]="sites"
        [(ngModel)]="selectedSites"
        optionLabel="name"
        display="chip"
        fluid
      ></p-multiSelect>
    </div>

    <small class="vc-admin-color-control__hint" *ngIf="exporting">
      {{ "ADMIN.DATA.EXPORT.ADVICE" | translate }}
    </small>

    <app-admin-form-actions
      primaryLabelKey="ADMIN.DATA.EXPORT.BUTTON"
      submittingLabelKey="ADMIN.DATA.EXPORT.BUTTON.EXPORTING"
      [submitting]="exporting"
      [disablePrimary]="!selectedSites.length || exporting"
    ></app-admin-form-actions>
  </section>
</form>
